import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiInstance } from "../../ApiSetUp/apiInstance";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl, LOGIN_TOKEN, REFRESH_TOKEN } from "../../ApiSetUp/AuthApi";
import { setToken } from "../../ApiSetUp/ClientHelper";
import localStoreUtil from "../../ApiSetUp/localstore.util";

export const getVandorOverviewAction = createAsyncThunk(
    "getVandorOverviewAction",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.VandorOverview, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPoStatusAction = createAsyncThunk(
    "getPoStatusAction",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPoStatus, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPoStatusTableAction = createAsyncThunk(
    "getPoStatusTableAction",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPoTableStatus, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getExpenseAction = createAsyncThunk(
    "getExpenseAction",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getExpense, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getSalesAndPurchaseAction = createAsyncThunk(
    "getExpenseAction",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getSalesAndPurchase, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getAllRevenueAction = createAsyncThunk(
    "getAllRevenueAction",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getAllRevenue, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);